import React from "react";
import { Link } from "react-router-dom";

const solutions = [
  {
    id: "mobilhazak",
    icon: "🚐",
    title: "Mobilházak",
    description: "Gyors, költséghatékony megoldás fix paraméterekkel. Azonnal beköltözhető, kulcsrakész otthonok.",
    price: "370.000 Ft/m²-től",
    link: "/mobilhazak",
    color: "from-blue-600 to-blue-800",
    features: ["Azonnal elérhető", "Fix ár", "Kulcsrakész"]
  },
  {
    id: "kesz-hazak",
    icon: "🏠",
    title: "Kész házak",
    description: "Azonnal vagy rövid időn belül költözhető ingatlanok. Meglévő, félkész vagy befejezett házak.",
    price: "Aktuális kínálat",
    link: "/kesz-hazak",
    color: "from-green-600 to-green-800",
    features: ["Azonnal költözhető", "Megtekinthető", "Telekáras"]
  },
  {
    id: "egyedi-hazak",
    icon: "🏗️",
    title: "Egyedi házak építése",
    description: "Fa, blokk vagy tégla szerkezettel – átlátható árakon, partneri kivitelezéssel.",
    price: "390.000 Ft/m²-től",
    link: "/egyedi-hazak",
    color: "from-secondary to-red-800",
    highlight: true,
    features: ["Személyre szabott", "3 szerkezet", "Kontrollált folyamat"]
  },
  {
    id: "ingatlan-piac",
    icon: "🏷️",
    title: "Ingatlan piactér",
    description: "Eladó és kiadó ingatlanok egy helyen. Töltsd fel ingatlanodat, vagy keress újat.",
    price: "Ingyenes hirdetés",
    link: "/ingatlan-piac",
    color: "from-purple-600 to-purple-800",
    features: ["Eladás", "Kiadás", "Keresés"]
  }
];

export default function SolutionsSection() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-black via-[#0a0a0a] to-[#1a1a1a] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-secondary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        
        {/* BREAKING STATEMENT - Monotony breaker */}
        <div className="mb-20 md:mb-28 text-center">
          <div className="inline-block bg-gradient-to-br from-secondary/20 via-red-600/20 to-secondary/20 backdrop-blur-xl rounded-3xl px-10 py-12 md:py-16 border-2 border-secondary/30 shadow-2xl shadow-secondary/20">
            <p className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
              „Nem háztervet választasz.
            </p>
            <p className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight mb-6">
              <span className="bg-gradient-to-r from-secondary via-red-500 to-secondary bg-clip-text text-transparent">Egy biztos építési rendszert.”</span>
            </p>
            <p className="text-gray-300 text-base md:text-xl max-w-2xl mx-auto font-light">
              Ez nem marketing szöveg. Ez a mi működésünk alapja.
            </p>
          </div>
        </div>
        
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600/20 to-blue-600/20 backdrop-blur-xl border border-purple-500/30 rounded-full px-6 py-3 mb-8 shadow-2xl shadow-purple-500/20">
            <span className="text-purple-400 font-bold text-sm tracking-wider">🛤️ MEGOLDÁSAINK</span>
          </div>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 tracking-tight">
            Válaszd ki az <span className="bg-gradient-to-r from-purple-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">utadat</span>
          </h2>
          <p className="text-gray-300 text-lg md:text-2xl max-w-3xl mx-auto font-light">
            Mindegy, honnan indulsz – mi tudjuk, hova érkezel.
          </p>
        </div>
        
        {/* Solution Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {solutions.map((solution) => (
            <Link
              key={solution.id}
              to={solution.link}
              className={`group relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl rounded-3xl overflow-hidden border-2 transition-all duration-500 no-underline
                ${solution.highlight 
                  ? 'border-secondary/50 hover:border-secondary shadow-2xl shadow-secondary/20 hover:shadow-secondary/40' 
                  : 'border-white/10 hover:border-white/30 shadow-xl'
                }
                hover:transform hover:scale-105 hover:shadow-2xl
              `}
            >
              {/* Highlight Badge */}
              {solution.highlight && (
                <div className="absolute top-3 right-3 bg-secondary text-white text-[10px] font-bold px-2 py-1 rounded-full">
                  NÉPSZERŰ
                </div>
              )}
              
              {/* Card Content */}
              <div className="p-6 md:p-8">
                {/* Icon */}
                <div className={`w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br ${solution.color} flex items-center justify-center text-3xl md:text-4xl mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
                  {solution.icon}
                </div>
                
                {/* Title */}
                <h3 className="text-xl md:text-2xl font-black text-white mb-3 group-hover:text-secondary transition-colors">
                  {solution.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-400 text-sm mb-4 leading-relaxed">
                  {solution.description}
                </p>
                
                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {solution.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="text-[10px] md:text-xs bg-white/5 text-gray-300 px-2 py-1 rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
                
                {/* Price */}
                <div className="flex items-center justify-between">
                  <span className="text-secondary font-bold text-sm">
                    {solution.price}
                  </span>
                  <span className="text-white/50 group-hover:text-secondary group-hover:translate-x-1 transition-all">
                    →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        {/* KAPSZULA HÁZAK - Coming Soon */}
        <div className="mt-8 md:mt-12">
          <div className="relative bg-gradient-to-br from-[#1a1a1a] via-[#1f1f1f] to-[#1a1a1a] rounded-2xl overflow-hidden border border-amber-500/20 p-6 md:p-8">
            {/* Coming Soon Badge */}
            <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-500 to-orange-500 text-black text-[10px] md:text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5 animate-pulse">
              <span>⏳</span>
              <span>HAMAROSAN</span>
            </div>
            
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              {/* Icon */}
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-gradient-to-br from-amber-500/20 to-orange-500/20 border border-amber-500/30 flex items-center justify-center text-4xl md:text-5xl flex-shrink-0">
                💊
              </div>
              
              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
                  Kapszula házak
                  <span className="text-amber-400 text-sm font-normal ml-2">2026 Q2</span>
                </h3>
                <p className="text-gray-400 text-sm md:text-base mb-4 max-w-xl">
                  Moduláris, futurisztikus lakóegységek – minimál helyigénnyel, maximális funkcionalitással. 
                  Tökéletes első otthonnak, nyaralónak vagy bérbeadásra.
                </p>
                <div className="flex flex-wrap justify-center md:justify-start gap-2">
                  <span className="text-[10px] md:text-xs bg-amber-500/10 text-amber-400 px-3 py-1 rounded-full border border-amber-500/20">
                    🏗️ Gyors telepítés
                  </span>
                  <span className="text-[10px] md:text-xs bg-amber-500/10 text-amber-400 px-3 py-1 rounded-full border border-amber-500/20">
                    📐 15-40 m²
                  </span>
                  <span className="text-[10px] md:text-xs bg-amber-500/10 text-amber-400 px-3 py-1 rounded-full border border-amber-500/20">
                    💰 Fix ár
                  </span>
                  <span className="text-[10px] md:text-xs bg-amber-500/10 text-amber-400 px-3 py-1 rounded-full border border-amber-500/20">
                    🔌 Off-grid opció
                  </span>
                </div>
              </div>
              
              {/* Notify Button */}
              <div className="flex-shrink-0">
                <button 
                  className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 hover:from-amber-500/30 hover:to-orange-500/30 border border-amber-500/30 hover:border-amber-500/50 text-amber-400 hover:text-amber-300 font-medium px-5 py-3 rounded-xl transition-all flex items-center gap-2"
                  onClick={() => alert('Hamarosan értesítünk a Kapszula házak indulásáról!')}
                >
                  <span>🔔</span>
                  <span>Értesíts</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Info */}
        <div className="mt-12 md:mt-16 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Bizonytalan vagy? <span className="text-white">Nem gond.</span>
          </p>
          <Link 
            to="/kapcsolat"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-secondary/20 border border-white/10 hover:border-secondary/50 text-white hover:text-secondary px-6 py-3 rounded-xl transition-all text-sm font-medium"
          >
            <span>Segítek dönteni →</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
